module.exports = "<div class=\"toast-container\" [@visibilityChanged]=\"toastService.visibility\" (@visibilityChanged.done)=\"animationDone($event)\">\n    <div class=\"toast {{toastService.type}}\">\n        <p>{{toastService.message | translate}}</p>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/toast/toast.component.html
// module id = 579
// module chunks = 0